import 'intersection-observer';
import 'abortcontroller-polyfill';
import { install } from 'resize-observer';
import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();
install();
